'use strict';
import Constants from '../constants';
import ObjectAssign from 'object-assign';


const initialState = {
    hydrated: false,
    loading: false,
    error: undefined,
    data: [],
    pages: {},
    items: {}
};
const reducer = function (state = initialState, action) {

    if (action.type === Constants.GET_ALL_FEATURE_FLAGS_BY_ORGANIZATION) {
        return ObjectAssign({}, state, {
            hydrated: false,
            loading: true
        });
    }

    if (action.type === Constants.GET_ALL_FEATURE_FLAGS_BY_ORGANIZATION_RESPONSE) {
        if ( !action.err) {
            return ObjectAssign({}, state, {
                hydrated: true,
                loading: false,
                data: action.response.data,
                pages: action.response.pages,
                items: action.response.items
            });
        }
        else {
            return ObjectAssign({}, state, {
                loading: false,
                error: action.err
            });
        }
    }

    return state;
};


export default reducer;
